<template>
  <div class="flex flex-wrap p-3 sm:p-6">
    <div class="w-full lg:w-8/12">
      <div class="h-full">
        <h5 class="intro-title text-xl px-3" v-if="$route.name === 'SpeechAI' && aiType === 'speech'">英文演講稿</h5>
        <h5 class="intro-title text-xl px-3" v-if="$route.name === 'SpeechAIJp' && aiType === 'speech'">日文演講稿</h5>
        <h5 class="intro-title text-xl px-3" v-if="$route.name === 'SpeechAI' && aiType === 'letter'">商用英文書信</h5>
        <h5 class="intro-title text-xl px-3" v-if="$route.name === 'SpeechAIJp' && aiType === 'letter'">商用日文書信</h5>
        <form v-if="step === 0 && aiType === 'speech'" >
          <p class="intro-title text-lg flex items-center mr-2 px-3"><img src="@/assets/image/ai/quote.png" alt="">演講資訊</p>
          <!-- <div class="form-group flex mx-0 mb-2">
            <label for="type" class="col-form-label mr-2 text-lg font-semibold form-label">Type</label>
            <div class="flex-1 border" :class="{ 'inValidError': isShowErr && !type }">
              <input type="text" class="form-control" id="type" placeholder="e.g. Host a meeting" v-model="type">
              <span class="text-sm text-red-main-ai m-0" v-if="isShowErr && !type">*此欄必須填寫</span>
            </div>
          </div> -->
          <div class="form-group flex mx-0 mb-2 px-3">
            <label for="topic" class="col-form-label mr-2 text-lg font-semibold form-label">主題</label>
            <div class="flex-1" :class="{ 'inValidError': isShowErr && !topic }">
              <input type="text" class="form-control" id="topic" :placeholder="`${$route.name === 'SpeechAI' ? 'e.g. ': '例： '}外賓來訪主持會議開場`" v-model="topic">
              <span class="text-sm text-red-main-ai m-0" v-if="isShowErr && !topic">*此欄必須填寫</span>
            </div>
          </div>
          <div class="form-group flex mx-0 mb-2 px-3">
            <label for="people" class="col-form-label mr-2 text-lg font-semibold form-label">對象</label>
            <div class="flex-1" :class="{ 'inValidError': isShowErr && !audience }">
              <input type="text" class="form-control" id="people" :placeholder="`${$route.name === 'SpeechAI' ? 'e.g. ': '例： '}客戶與公司一級主管`" v-model="audience">
              <span class="text-sm text-red-main-ai m-0" v-if="isShowErr && !audience">*此欄必須填寫</span>
            </div>
          </div>
          <div class="form-group px-3" :class="{ 'inValidError': isShowErr && !content }">
            <label for="detail" class="text-lg font-semibold form-label mb-3 block">內容簡述 (字數上限100字)</label>
            <textarea v-model="content" class="form-control h-auto w-full" id="detail" rows="8"
            :placeholder="`${$route.name === 'SpeechAI' ? 'e.g. ': '例： '}：
1. 向遠道而來的外賓表達歡迎詞
2. 進行簡單自我介紹
3. 針對會議目的和今天的議程，進行概要說明
4. 誠摯表達與對方合作的期待

提醒：建議以列點的方式簡述您欲演講的段落架構，讓小幫手協助您產出更符合需求的內容`"></textarea>
            <span class="text-sm text-red-main-ai m-0" v-if="isShowErr && !content">*此欄必須填寫</span>
          </div>
          <div class="w-full flex justify-center mt-3">
            <!-- <a class="btn-clear mx-2 inline-block" @click="reset">清空</a> -->
            <a class="btn-submit mx-2 inline-block py-2" @click="createLetter()">START</a>
          </div>
        </form>
        <form v-if="step === 0 && aiType === 'letter'">
          <div class="flex flex-wrap">
            <div class="w-full lg:w-6/12 px-3 mb-2">
              <p class="intro-title text-lg flex items-center mr-2"><img src="@/assets/image/ai/quote.png" alt="">寄件人資訊</p>
              <div class="form-group flex mx-0 mb-2">
                <label for="SenderName" class="col-form-label mr-2 text-lg font-semibold form-label">寄件人姓名</label>
                <div class="flex-1" :class="{ 'inValidError': isShowErr && !s_name }">
                  <input type="text" class="form-control" id="SenderName" :placeholder="`${$route.name === 'SpeechAI' ? 'e.g. Emily': '例：田中太郎'}`" v-model="s_name">
                  <span class="text-sm text-red-main-ai m-0" v-if="isShowErr && !s_name">*此欄必須填寫</span>
                </div>
              </div>
              <div class="form-group flex mx-0 mb-2" v-if="$route.name === 'SpeechAIJp'">
                <label for="SenderName" class="col-form-label mr-2 text-lg font-semibold form-label">寄件人稱謂</label>
                <div class="flex-1" :class="{ 'inValidError': isShowErr && !s_itentity }">
                  <input type="text" class="form-control" id="SenderName" placeholder="例：業務專員" v-model="s_itentity">
                  <span class="text-sm text-red-main-ai m-0" v-if="isShowErr && !s_itentity">*此欄必須填寫</span>
                </div>
              </div>
              <div class="form-group flex mx-0 mb-2">
                <label for="SenderDepartment" class="col-form-label mr-2 text-lg font-semibold form-label">寄件人公司</label>
                <div class="flex-1" :class="{ 'inValidError': isShowErr && !s_company }">
                  <input type="text" class="form-control" id="SenderDepartment" :placeholder="`${$route.name === 'SpeechAI' ? 'e.g. ABC company': '例：ABC 公司'}`" v-model="s_company">
                  <span class="text-sm text-red-main-ai m-0" v-if="isShowErr && !s_company">*此欄必須填寫</span>
                </div>
              </div>
            </div>
            <div class="w-full lg:w-6/12 px-3">
              <p class="intro-title text-lg flex items-center mr-2"><img src="@/assets/image/ai/quote.png" alt="">收件人資訊</p>
              <div class="form-group flex mx-0 mb-2">
                <label for="addresseeName" class="col-form-label mr-2 text-lg font-semibold form-label">收件人姓名</label>
                <div class="flex-1" :class="{ 'inValidError': isShowErr && !r_name }">
                  <input type="text" class="form-control" id="addresseeName" :placeholder="`${$route.name === 'SpeechAI' ? 'e.g. Emily': '例：山本花子'}`" v-model="r_name">
                  <span class="text-sm text-red-main-ai m-0" v-if="isShowErr && !r_name">*收件人公司</span>
                </div>
              </div>
              <div class="form-group flex mx-0 mb-2" v-if="$route.name === 'SpeechAIJp'">
                <label for="addresseeName" class="col-form-label mr-2 text-lg font-semibold form-label">收件人稱謂</label>
                <div class="flex-1" :class="{ 'inValidError': isShowErr && !r_itentity }">
                  <input type="text" class="form-control" id="addresseeName" placeholder="例：業務經理" v-model="r_itentity">
                  <span class="text-sm text-red-main-ai m-0" v-if="isShowErr && !r_itentity">*此欄必須填寫</span>
                </div>
              </div>
              <!-- <div class="form-group flex mx-0">
                <label for="addresseeAppellation" class="col-form-label mr-2 text-lg font-semibold form-label">收件人稱謂</label>
                <div class="flex-1">
                  <input type="text" class="form-control" id="addresseeAppellation" placeholder="EX: Apple CEO">
                </div>
              </div> -->
              <div class="form-group flex mx-0 mb-2">
                <label for="addresseeDepartment" class="col-form-label mr-2 text-lg font-semibold form-label">收件人公司</label>
                <div class="flex-1" :class="{ 'inValidError': isShowErr && !r_company }">
                  <input type="text" class="form-control" id="addresseeDepartment" :placeholder="`${$route.name === 'SpeechAI' ? 'e.g. XYZ company': '例：XYZ 公司'}`" v-model="r_company">
                  <span class="text-sm text-red-main-ai m-0" v-if="isShowErr && !r_company">*此欄必須填寫</span>
                </div>
              </div>
            </div>
            <div class="w-full px-3">
              <p class="intro-title text-lg flex items-center mr-2"><img src="@/assets/image/ai/quote.png" alt="">信件資訊</p>
                <div class="form-group mb-3" :class="{ 'inValidError': isShowErr && !purpose }">
                  <label for="emailTitle" class="text-lg font-semibold form-label mb-2 block">信件主旨</label>
                  <input type="text" class="form-control" id="emailTitle" :placeholder="`${$route.name === 'SpeechAI' ? 'e.g. 專案合作細節洽談': '例：專案合作細節洽談'}`" v-model="purpose">
                  <span class="text-sm text-red-main-ai m-0" v-if="isShowErr && !purpose">*此欄必須填寫</span>
                </div>
                <div class="form-group mb-3" :class="{ 'inValidError': isShowErr && !content }">
                  <label for="emailTitle" class="text-lg font-semibold form-label mb-2 block">內容簡述 (字數上限100字)</label>
                  <textarea class="form-control h-auto w-full" id="emailTitle" rows="8" :placeholder="`${$route.name === 'SpeechAI' ? 'e.g. ': '例： '}： 關於本次新產品專案合作細節，針對上市時程、合作細節、分潤模式，希望能約貴公司下週進行當面會談，以利雙方業務推展。`" v-model="content"></textarea>
                  <span class="text-sm text-red-main-ai m-0" v-if="isShowErr && !content">*此欄必須填寫</span>
                </div>
            </div>
            <div class="w-full flex justify-center">
              <!-- <a class="btn-clear mx-2 inline-block" @click="reset">清空</a> -->
              <a class="btn-submit mx-2 inline-block py-2" @click="createLetter()">START</a>
            </div>
          </div>
        </form>
        <GenerateResults v-if="step === 1"
        :resultsEn="resultsEn" :resultsZh="resultsZh" :ttsUrlMale="ttsUrlMale" :ttsUrlFemale="ttsUrlFemale" :aiType="aiType"
        v-on:resultsZh="emitResultsZh" v-on:failPopUp="failPopUp" v-on:getZnPopUp="getZnPopUp" />
      </div>
    </div>
    <div class="w-full lg:w-4/12 mt-3 lg:mt-0 px-3">
      <Rule v-if="step === 0" :aiType="aiType" />
      <InputData v-if="step === 1 || step === 2" v-on:editData="editData" :aiType="aiType" :topic="topic" :content="content" :audience="audience" :r_name="r_name" :r_itentity="r_itentity" :s_name="s_name" :s_itentity="s_itentity" :purpose="purpose" :s_company="s_company" :r_company="r_company"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import Rule from '@/components/AiHelper/rule.vue'
import InputData from '@/components/AiHelper/speech/inputData.vue'
import GenerateResults from '@/components/AiHelper/speech/generateResults.vue'
import allJs from '@/components/all.js'
export default {
  name: 'Speech',
  metaInfo: {
    title: 'AI生成小助教'
  },
  components: {
    Rule,
    InputData,
    GenerateResults
  },
  computed: {
    ...mapGetters([
      'authorized',
      'remainPoints',
      'ai_sid'
    ]),
    aiType () {
      return this.$route.params.aiType
    }
  },
  mixins: [
    allJs
  ],
  watch: {
    'aiType': {
      async handler (newVal, oldVal) {
        if (newVal && (newVal !== oldVal)) {
          this.step = 0
        }
      },
      immediate: true
    },
    '$route': {
      async handler (newVal, oldVal) {
        if (newVal !== oldVal && this.step === 1) {
          this.editData()
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      step: 0,
      isShowErr: false,

      content: null,

      topic: null,
      audience: null,

      r_name: null,
      r_itentity: null,
      r_company: null,
      s_name: null,
      s_itentity: null,
      s_company: null,
      purpose: null,

      // topic: '設立界線對於建立健康人際關係的益處',
      // content: '暢銷大眾心理學者針對設立界線主題寫書，並且在書店扮演講',
      // audience: '讀者',

      // r_name: 'Leo',
      // r_itentity: 'LiveABC',
      // s_name: 'Rex',
      // s_itentity: 'LiveABC',
      // purpose: '談合作策略',
      // content: '如何善用兩公司優勢創照1+1大於2的力量',

      resultsEn: null,
      resultsZh: null,
      ttsUrlMale: null,
      ttsUrlFemale: null
    }
  },
  mounted () {
    this.$store.dispatch('getRemainPoints')

    this.$route.name === 'viewGenerate' ? this.viewRecord() : null

    this.$store.dispatch('setAccent', 'en-EN')
  },
  methods: {
    viewRecord () {
      let self = this
      let type = self.$route.params.aiType === 'speech' ? 'speeches' : 'letters'
      let path = `/ai/${type}/${self.$route.params.promptId}`
      self.$store.dispatch('isLoading', true)
      api.get(path)
      .then(async(res) => {
        self.$store.dispatch('isLoading', false)
        self.resultsEn = res.data.result

        self.step = 1

        // eslint-disable-next-line
        self.ttsUrlFemale = await self.getTTSUrl('female', res.data.result)
        self.ttsUrlMale = await self.getTTSUrl('male', res.data.result)
      })
      .catch(() => {
        self.$store.dispatch('isLoading', false)
      })
    },

    emitResultsZh (emitResultsZh) {
      let self = this
      self.resultsZh = emitResultsZh
    },

    editData () {
      let self = this
      self.step = 0
      self.resultsZh = null
    },

    createLetter () {
      let self = this
      self.$store.dispatch('getRemainPoints')

      if (((self.$route.name === 'SpeechAI' && self.aiType === 'speech') && self.topic && self.content && self.audience) ||
      ((self.$route.name === 'SpeechAIJp' && self.aiType === 'speech') && self.topic && self.content && self.audience) ||
      ((self.$route.name === 'SpeechAI' && self.aiType === 'letter') && self.r_name && self.s_name && self.purpose && self.content && self.r_company && self.s_company) ||
      ((self.$route.name === 'SpeechAIJp' && self.aiType === 'letter') && self.r_name && self.r_itentity && self.s_name && self.s_itentity && self.purpose && self.content && self.r_company && self.s_company)) {
        if (self.remainPoints < 20) {
          self.ai_sid ? self.failPopUp('點數不足') : self.notEnoughPoints()
        } else {
          self.swal_startCreate()
        }
      } else {
        self.isShowErr = true
      }
    },

    swal_startCreate () {
      let self = this
      let typeText = '商用英文書信'
      let calPoints = self.remainPoints - 20
      self.aiType === 'speech' ? typeText = '英文演講稿' : null
      self.$swal({
        html: `<h3>確定開始生成${typeText}？</h3><p>目前總點數 <span style="color: #F30000;">${self.remainPoints}</span> 點</p><p>需扣除 20 點</p><p>扣除後點數 <span style="color: #F30000;">${calPoints}</span> 點</p>`,
        showDenyButton: true,
        focusConfirm: false,
        confirmButtonText: `確認`,
        denyButtonText: `返回修改`,
        title: 'Notice',
        customClass: {
          title: 'text-white',
          container: '',
          popup: 'p-0',
          header: 'swal-header-notice justify-center items-center',
          closeButton: '',
          htmlContainer: 'htmlContainer my-3',
          actions: 'mb-4 mt-5 flex',
          confirmButton: 'btn-submit order-2',
          denyButton: 'denyButton-ai order_1',
        }
      })
        .then((result) => {
          if (result.isConfirmed === true) {
            self.postData()
          }
        }
      )
    },

    async postData () {
      let self = this
      let jsonData
      if (self.aiType === 'letter') {
        jsonData = {
          r_name: self.r_name,
          r_itentity: self.r_company,

          s_name: self.s_name,
          s_itentity: self.s_company,

          letter_purpose: self.purpose,
          letter_content: self.content
        }

        if (self.$route.name === 'SpeechAIJp') {
          jsonData.r_itentity = self.r_itentity
          jsonData.r_company = self.r_company
          jsonData.s_itentity = self.s_itentity
          jsonData.s_company = self.s_company
        }
      } else {
        jsonData = {
          // type: self.type,
          s_topic: self.topic,
          speech_content: self.content,
          audience: self.audience
        }
      }

      let prompt_id = '512963b7-c9f4-41d8-8ce8-20d23fc1b110'

      if (self.$route.name === 'SpeechAI' && self.aiType === 'speech') {
        prompt_id = '4644d774-ea57-43ea-a610-1d9f8bd91384'
      } else if (self.$route.name === 'SpeechAIJp' && self.aiType === 'letter') {
        prompt_id = 'fc170c16-bb1f-4acc-a901-23ba29bbb775'
      } else if (self.$route.name === 'SpeechAIJp' && self.aiType === 'speech') {
        prompt_id = '19d64b66-a359-4065-b4da-86ce55fddeb7'
      }

      let path = `/ai/generate/${prompt_id}`
      self.$store.commit('isLoading', true)

      self.$store.dispatch('isLoading', true)
      await api.post(path, JSON.stringify(jsonData))
      .then(async(res) => {
        self.$store.commit('isLoading', false)
        if (res.data && res.data.result) {
          self.resultsEn = res.data.result

          self.step = 1

          // eslint-disable-next-line
          self.ttsUrlFemale = await self.getTTSUrl('female', res.data.result)
          self.ttsUrlMale = await self.getTTSUrl('male', res.data.result)

          self.$store.dispatch('isLoading', false)

          self.$store.dispatch('getRemainPoints')
        } else {
          self.failPopUp()
          self.$store.dispatch('isLoading', false)
        }
      })
      .catch((err) => {
        self.failPopUp(err.response.data.result)
        self.$store.commit('isLoading', false)
      })
    },
    notEnoughPoints () {
      let self = this
      let html = `<p class="text-lg text-black mb-5 font-semibold">點數餘額不足支付本課程，請於LiveABC官網加購</p>
        <a href="https://store.liveabc.com/products/digital?category=221" target="_blank" class="text-xl gept_main_bg5 text-white mb-3 font-semibold cursor-pointer px-3 py-2 inline-block">購買網址</a>`
      self.$swal.fire({
        html: html,
        showCloseButton: true,
        showDenyButton: false,
        showConfirmButton: false,
        focusConfirm: false,
        confirmButtonText: `確認`,
        customClass: {
          container: '',
          popup: 'p-0',
          header: 'swal-header',
          closeButton: '',
          htmlContainer: 'htmlContainer my-3',
          actions: 'mb-4 mt-5',
          confirmButton: 'btn-submit',
          cancelButton: 'bg-red-main-ai',
        }
      })
    },

    failPopUp (txt) {
      let self = this
      self.$swal.fire({
        html: `<h3>生成失敗</h3><p>糟糕！發生了一點小失誤，請再給我一次機會！</p><p v-if="txt">${txt}</p>`,
        text: 'gg',
        showCloseButton: true,
        focusConfirm: false,
        confirmButtonText: `確認`,
        customClass: {
          container: '',
          popup: 'p-0',
          header: 'swal-header',
          closeButton: '',
          htmlContainer: 'htmlContainer my-3',
          actions: 'mb-4 mt-5',
          confirmButton: 'btn-submit',
          cancelButton: 'bg-red-main-ai',
        }
      })
    },

    getZnPopUp () {
      let self = this
      self.$swal.fire({
        html: `<h3>翻譯完成</h3>`,
        showCloseButton: false,
        focusConfirm: false,
        confirmButtonText: `確認`,
        customClass: {
          container: '',
          popup: 'p-0',
          header: 'swal-header-success',
          closeButton: '',
          htmlContainer: 'htmlContainer my-3',
          actions: 'mb-4 mt-5',
          confirmButton: 'btn-submit',
          cancelButton: 'bg-red-main-ai',
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  form {
    label {
      // white-space: nowrap;
      white-space: pre-wrap;
    }
    .form-label {
      @media (max-width: 1024px) {
        font-size: 1rem;
      }
    }
  }
  .intro-title {
    color: #F30000;
    font-weight: 700;
    margin-bottom: 0.75rem;
    @media (max-width: 1024px) {
      font-size: 1.125rem;
    }
  }
</style>
